// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview Index file for Sisense Event Model.
 * Implementation based on Google Closure Library goog.events package
 * @link https://google.github.io/closure-library/api/goog.events.html
 * @author artem.lit@sisense.com (Artem Lytvynov)
 * @copyright sisense@sisense.com (Sisense Ltd.)
 * @license Sisense License
 * @module @sbi/core.events
 */

'use strict';

/**
 * @type {EventTarget}
 */
const EventTarget = require('./eventtarget').EventTarget;

/**
 * @type {Event}
 */
const Event = require('./event').Event;

exports.EventTarget = EventTarget;
exports.Event = Event;
